export type TextWithHighlight = {
  type: 'text' | 'highlight';
  value: string;
}[];

export const highlightText = (
  text: string,
  value: string
): TextWithHighlight => {
  const result: TextWithHighlight = [];

  if (!value) {
    result.push({ type: 'text', value: text });
    return result;
  }

  const pattern = new RegExp(
    `(${value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
    'gi'
  );
  let lastIndex = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    // Добавляем текст до совпадения
    if (match.index > lastIndex) {
      result.push({
        type: 'text',
        value: text.slice(lastIndex, match.index)
      });
    }
    // Добавляем выделенное совпадение
    result.push({
      type: 'highlight',
      value: match[0]
    });
    lastIndex = pattern.lastIndex;
  }

  // Добавляем оставшийся текст
  if (lastIndex < text.length) {
    result.push({
      type: 'text',
      value: text.slice(lastIndex)
    });
  }

  return result;
};
